import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";

const APP_ID = process.env.REACT_APP_ONESIGNAL_APP_ID;
let sdkLoaded = false;

export default function OneSignalInit() {
  const { user } = useAuth();

  // Load the OneSignal Web SDK and initialize once
  useEffect(() => {
    if (!APP_ID || sdkLoaded) return;
    sdkLoaded = true;
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    const script = document.createElement("script");
    script.src = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js";
    script.defer = true;
    document.head.appendChild(script);
    window.OneSignalDeferred.push(async (OneSignal) => {
      try {
        await OneSignal.init({ appId: APP_ID, allowLocalhostAsSecureOrigin: true });
      } catch (e) { /* already initialized */ }
    });
  }, []);

  // Tie the push/email identity to the signed-in user
  useEffect(() => {
    if (!APP_ID) return;
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async (OneSignal) => {
      try {
        if (user && user !== false && user.id) {
          await OneSignal.login(String(user.id));
          if (user.email) { try { await OneSignal.User.addEmail(user.email); } catch (e) {} }
        } else if (user === false) {
          try { await OneSignal.logout(); } catch (e) {}
        }
      } catch (e) { /* noop */ }
    });
  }, [user]);

  return null;
}
